/**
 * @module lib/commercial/keytar/flash-sale-paywall-hard/template
 */
import Template, { BLOCKOUT_TYPES } from "lib/commercial/keytar/Template";
import consts from "lib/consts";
import tgamConfig from "config/tgam";
import { setUpTeaserView } from "lib/commercial/keytar/common/teaser";

/** @type {String} */
const wallType = "hardPaywall";
const blockoutType = tgamConfig.meta.isStoryInteractivePage ? BLOCKOUT_TYPES.EVERYTHING : BLOCKOUT_TYPES.PREVIEW;

const props = {
  blockoutType,
  darwinRenderKey: wallType,
  /**
   * @method render
   * @description Always render the paywall template.
   * @returns {Promise<Boolean>} true if rendered
   */
  render() {
    const paragraphs = 0;
    this.updateTeaserAnalytics(paragraphs);
    const contentType = this.parentContext.contentType;

    setUpTeaserView(wallType, () => {
      return flashSaleTemplate("redwall-cemfsale", "To continue reading this article, you must be a globeandmail.com subscriber. Become one now.");
    }, paragraphs, contentType);

    return Promise.resolve(true);
  }
};

export function flashSaleTemplate(intcmp, text) {
  return `
    <div id="main_modal" class="red">
      <div class="paywall-body">
        <a target="_parent" href="${consts.URLS.SUBSCRIBE.DIGITAL}?intcmp=${intcmp}" >
          <div id="modalHeader" class="text font__pratt-bold">${text}</div>
          <div class="images_modal"></div>
        </a>
      </div>
      <div id="modalFooter">
        <div id="footerContent">
          <p class="font__pratt">Already a print newspaper subscriber?
            <a class="font__pratt-bold" id="footerClickHere" href="${consts.URLS.LINK_PRINT_ACCOUNT}"
              target="_parent">Get full access to globeandmail.com
            </a>
          </p>
          <p class="font__pratt">Already subscribed to globeandmail.com?
            <a class="font__pratt-bold js-keytar-algt" id="footerLogIn"
              href="${consts.URLS.LOGIN}" target="_parent">Log in to keep reading</a>
          </p>
        </div>
      </div>
    </div>
    <style>
      .c-keytar-container--teaser {
        margin-bottom: 1.25rem;
      }

      #main_modal .paywall-body {
        box-shadow: none;
        -webkit-box-shadow: none;
        -moz-box-shadow: none;
        width: 100% !important;
        padding: 0px !important;
        background: #ffffff;
      }

      #main_modal {
        width: 100% !important;
        max-width: 908px;
        border-radius: 0px;
        -moz-border-radius: 0px;
        -webkit-border-radius: 0px;
        overflow: visible;
        position: relative;
        margin: 0 auto;
        border: 1px solid #191919;
      }

      .images_modal {
        width: 100%;
        margin-top: -30px;
        max-width: 908px;
        margin: 0 auto;
        display: block;
        background-size: 100%;
        background-repeat: no-repeat;
        width: 100%;
        height: 0;
        /*Increase or decrease padding % if the height doesnt match */
        padding-top: 105%;
      }

      #main_modal a,
      #main_modal .red {
        color: #da161f;
        text-decoration: none;
      }

      #main_modal .modal-footer {
        background: transparent;
        border-top: 0px;
        padding-top: 0px;
        padding: 5px 15px !important;
        position: absolute;
        z-index: 1063;
        border: 0px !important;
        width: 100%;
        box-shadow: none;
        bottom: 4px;
        color: #000;
        font-size: 13px;
      }

      #main_modal .modal-footer p {
        float: left;
        margin: 0px 22px;
      }

      #main_modal .modal-footer p a {
        text-decoration: underline;
        font-weight: 600;
        color: #000;
      }

      #modalFooter {
        display: -webkit-box;
        /* OLD - iOS 6-, Safari 3.1-6 */
        display: -moz-box;
        /* OLD - Firefox 19- (buggy but mostly works) */
        display: -ms-flexbox;
        /* TWEENER - IE 10 */
        display: -webkit-flex;
        display: flex;
        -webkit-align-items: center;
        align-items: center;
        -ms-flex-align: center;
        padding: 13px;
        background: #ffffff;
      }

      #modalFooter #footerContent {
        -webkit-prop: 0.93;
        -moz-flex: 0.93;
        -ms-flex: 0.93;
        flex: 0.93;
        font-size: 0.9em;
        padding-left: 13px;
        padding-right: 20px;
        color: #595959;
      }

      #modalFooter #footerContent p {
        margin-top: 5px;
        margin-bottom: 5px;
        letter-spacing: 0.3px;
      }

      #modalFooter #footerContent a {
        text-decoration: none;
        color: inherit !important;
      }

      @media (max-width: 720px) {
        #modalFooter {
          display: block;
          text-align: center;
          padding: 0 13px 13px 13px;
        }

        #modalFooter p {
          margin-top: 10px !important;
          margin-bottom: 10px !important;
        }
      }

      .images_modal {
        padding-top: 130% !important;
        background-image: url("https://www.theglobeandmail.com/files/cem/flashsale/2021/oct/paywall-320.jpg");
      }

      #main_modal .text {
        background: #ffffff;
        color: #191919;
        padding: 15px;
      }

      /*Tablet Large > 480px*/
      @media (min-width:30em) {
        .images_modal {
          padding-top: 85% !important;
          background-image: url("https://www.theglobeandmail.com/files/cem/flashsale/2021/oct/paywall-768.jpg");
        }

        #main_modal .text {
          padding: 20px;
        }

      }

      /*Desktop Large > 768*/
      @media (min-width:48em) {
        .images_modal {
          padding-top: 85% !important;
          background-image: url("https://www.theglobeandmail.com/files/cem/flashsale/2021/oct/paywall-768.jpg");
        }
      }
  </style>
  `;
}

export default new Template(props);
